module.exports = __webpack_public_path__ + "img/官网-V1_07.01d0c737.png";